export const aboutItems = [
  {
    icon: 'ri-shield-check-line',
    title: '투명한 검증 절차',
    desc: '전문가 검증팀이 체계적인 기준으로 사이트를 검증하고 공정한 결과를 투명하게 공개합니다.',
  },
  {
    icon: 'ri-lock-line',
    title: '개인정보 보호',
    desc: '사용자의 개인정보와 피해 내역은 철저히 암호화되어 안전하게 보호됩니다.',
  },
  {
    icon: 'ri-refresh-line',
    title: '상시 검증 상태 확인',
    desc: '등록된 사이트의 실시간 검증 상태를 지속적으로 모니터링하고 업데이트합니다.',
  },
  {
    icon: 'ri-camera-line',
    title: '청결 및 이력신청',
    desc: '공정한 검증을 위해 신뢰할 수 있는 검증 이력과 증빙 자료를 투명하게 공개합니다.',
  },
];

export const damageTypes = [
  {
    icon: 'ri-money-cny-circle-line',
    title: '출금 전 추가 입금 요구',
    desc: '추가 입금을 요구하며 출금을 지연시키는 수법',
  },
  {
    icon: 'ri-mail-line',
    title: '멤버십 고객센터 사칭',
    desc: '가짜 고객센터를 통해 추가 입금을 유도하는 수법',
  },
  {
    icon: 'ri-lock-unlock-line',
    title: '보다스 규정 악용 출금 거절',
    desc: '약관을 악용하여 정당한 출금을 거부하는 수법',
  },
  {
    icon: 'ri-user-settings-line',
    title: '계좌차단 및 연락 두절',
    desc: '갑작스럽게 계좌를 차단하고 연락을 두절하는 수법',
  },
  {
    icon: 'ri-time-line',
    title: '사이트 주소 번복 변경',
    desc: '사이트 주소를 자주 변경하여 피해를 확산시키는 수법',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: '개인정보 요구 및 유출 위협',
    desc: '개인정보를 요구하고 유출을 위협하는 수법',
  },
];

export const preventionSteps = [
  '먹튀사이트 구별하는 10가지 체크리스트',
  '입금 전 안전한 커뮤니티에서 기간 확인',
  '홈페이지 연락처, 회원가입 양식 확인',
  '업체별 시세 적정 규정 및 이벤트 확인',
  '피해 발생 시 즉시자료 확보 및 가이드',
  '안전한 사이트 선택하는 기준',
  '개인정보 보호를 위한 주의사항',
];

export const responseMethods = [
  '출금 전 추가 입금을 요구받았을 때',
  '출금이 차단되거나 거부당했을 때',
  '계좌가 차단되거나 입금받을 수 없을 때',
  '사이트가 접근 차단되거나 사라졌을 때',
  '개인정보를 요구받았을 때',
];

export const preventionGuide = [
  '먹튀사이트 구별하는 방법 총정리',
  '안전한 사이트 선택하는 기준',
  '보증업체 확인 및 보증금 제도 이용하기',
  '작은 금액으로 먼저 테스트 후 이용하기',
  '먹튀 검증 사이트 활용 방법',
];

export const notices = [
  { category: '공지', title: '스카연 앱 다운로드 안내 및 설치 방법', date: '07.01' },
  { category: '공지', title: '커뮤니티 이용 규정 및 주의사항 안내', date: '06.28' },
  { category: '업데이트', title: '검증 기준 변경 및 신규 기능 업데이트', date: '06.25' },
  { category: '공지', title: '신규 제휴업체 추가 안내', date: '06.20' },
  { category: '공지', title: '피해제보 안내 및 접수 방법', date: '06.15' },
];

export const latestPosts = [
  { category: '커뮤니티', title: '새로운 사이트 먹튀 검증 결과 공개', author: '운영팀', time: '1시간 전' },
  { category: '커뮤니티', title: '이용 가이드 업데이트 안내', author: '관리자', time: '3시간 전' },
  { category: '커뮤니티', title: '업체별 시세 적정 조사내역서', author: '검증팀', time: '5시간 전' },
  { category: '커뮤니티', title: '보증 금액 거래 내역 보장 확인', author: '운영팀', time: '7시간 전' },
  { category: '커뮤니티', title: '주요 사건 사고 대처 가이드라인', author: '관리자', time: '12시간 전' },
];

export const verificationSteps = [
  { step: 1, title: '1. 제보 접수', desc: '사이트명과 URL\n주요 피해 내용 접수' },
  { step: 2, title: '2. 기본 확인', desc: '사이트 운영 기간\n도메인 정보 확인' },
  { step: 3, title: '3. 보증 검증', desc: '보증금 유무 확인\n보증업체 여부 검증' },
  { step: 4, title: '4. 운영 검토', desc: '서버 및 운영진\n실제 운영 상태 파악' },
  { step: 5, title: '5. 결과 공개', desc: '검증 결과 및 등급\n투명하게 공개' },
];

export const faqs = [
  { question: '먹튀검증을 받기 위한 기준은 무엇인가요?', answer: '스카연은 사이트의 운영 기간, 보증금 유무, 사용자 후기, 서버 안정성 등 다양한 기준을 종합적으로 검토하여 검증 결과를 도출합니다.' },
  { question: '제보접수는 어떻게 하나요?', answer: '상단 메뉴의 "피해 제보하기" 버튼을 클릭하시거나, 커뮤니티 게시판에서 제보글을 작성하실 수 있습니다. 가능한 상세한 정보를 제공해 주세요.' },
  { question: '먹튀당한 증거 자료는 어떤 것이 유용한가요?', answer: '입금 내역, 출금 거절 내역, 대화 내역(캡처), 사이트 주소, 계좌번호 등이 유용합니다. 시간 순서대로 정리해 주시면 더 효과적입니다.' },
  { question: '증거자료는 어떤 형식의 제출해야 하나요?', answer: '이미지(JPG, PNG) 또는 PDF 형식으로 제출 가능합니다. 파일 크기는 개당 10MB 이하로 제한됩니다.' },
  { question: '피해 보상은 어떻게 이루어지나요?', answer: '보증업체를 통해 이용하신 경우 보증금 범위 내에서 보상이 가능합니다. 자세한 내용은 개별 상담을 통해 안내해 드립니다.' },
  { question: '스카연 커뮤니티의 이용규정은 어떻게 되나요?', answer: '허위 제보 금지, 타인 비방 금지, 광고 및 홍보 금지 등 기본적인 커뮤니티 예절을 준수해 주시면 됩니다.' },
  { question: '검증 결과는 얼마나 자주 업데이트 되나요?', answer: '등록된 사이트는 매주 정기적으로 재검증하며, 신규 제보 접수 시 우선적으로 추가 검증을 진행합니다.' },
];

export const trustItems = [
  { icon: 'ri-shield-star-line', title: '철저한 검증 기준', desc: '엄격한 검증 기준으로\n신뢰할 수 있는 정보만 제공합니다.' },
  { icon: 'ri-camera-lens-line', title: '개인정보 보호', desc: '제보자의 신원과 정보는\n철저하게 보호됩니다.' },
  { icon: 'ri-team-line', title: '광고·이해관계 배제', desc: '광고 및 업체와의\n이해관계를 원칙적으로 배제합니다.' },
  { icon: 'ri-shield-check-line', title: '자체적인 모니터링', desc: '신규 검증 대상을\n지속적으로 모니터링합니다.' },
  { icon: 'ri-scales-3-line', title: '이용자 참여 존중', desc: '이용자의 제보와 의견을\n소중하게 반영합니다.' },
  { icon: 'ri-customer-service-2-line', title: '필요한 정보 제공', desc: '확인되고 검증된 정보만\n소통하여 제공합니다.' },
];

export const operationStatus = [
  { label: '등록된 제보접수', value: '4,385' },
  { label: '구축 완료 건', value: '3,912' },
  { label: '이용 기준', value: '142' },
  { label: '검증 기준', value: '공개 운영' },
  { label: '최신 업데이트', value: '2026.07.03' },
];

export const quickLinks = [
  '검증기준에 따라 검증된',
  '자가검증',
  '분석',
  '리스트',
  '커뮤니티',
  'DB검색',
  '검증센터',
];

export const footerLinks = {
  services: [
    { label: '먹튀검증', href: '/search' },
    { label: '피해사례', href: '/board' },
    { label: '먹튀사이트', href: '/search' },
    { label: '제보하기', href: '/report' },
    { label: '검증리스트', href: '/search' },
    { label: '이용가이드', href: '/#faq' },
  ],
  guides: [
    { label: '이용안내', href: '/#faq' },
    { label: '출금가이드', href: '/#prevention' },
    { label: '보증가이드', href: '/#prevention' },
    { label: '개인정보처리방침', href: '#' },
    { label: '이용약관', href: '#' },
  ],
  company: [
    { label: '고객센터', href: '/report' },
    { label: '공지사항', href: '/board' },
    { label: '이용문의', href: '/report' },
    { label: '사이트맵', href: '#sitemap' },
  ],
  legal: [
    { label: '정책', href: '#' },
    { label: '이의신청', href: '/report' },
    { label: '개인정보처리방침', href: '#' },
    { label: '최신 제보 접수 기준', href: '/board' },
  ],
};

export const damageCategories = [
  { label: '출금전', active: true },
  { label: '검증가이드', active: false },
  { label: '분석', active: false },
  { label: '리스트', active: false },
  { label: '커뮤니티', active: false },
  { label: 'DB검색', active: false },
  { label: '검증센터', active: false },
  { label: '등록', active: false },
];

export const navItems = [
  { label: '먹튀검증', href: '/search', active: true },
  { label: '피해사례', href: '/board', active: false },
  { label: '예방가이드', href: '/#prevention', active: false },
  { label: '커뮤니티', href: '/board', active: false },
  { label: '검증기준', href: '/#verification', active: false },
  { label: '이용안내', href: '/#faq', active: false },
  { label: '고객센터', href: '/report', active: false },
];